import { render, staticRenderFns } from "./CardSurveyProcess.vue?vue&type=template&id=228e67f7&scoped=true"
import script from "./CardSurveyProcess.vue?vue&type=script&lang=js"
export * from "./CardSurveyProcess.vue?vue&type=script&lang=js"
import style0 from "./CardSurveyProcess.vue?vue&type=style&index=0&id=228e67f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228e67f7",
  null
  
)

export default component.exports